"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSizeClassName = exports.getViewClassName = void 0;
var SIZES_MAP = {
  s: 'small',
  m: 'medium',
  l: 'large',
  c: 'custom'
};

var getViewClassName = function getViewClassName(styles, view) {
  return styles["".concat(view, "-view")] || '';
};

exports.getViewClassName = getViewClassName;

var getSizeClassName = function getSizeClassName(styles, size) {
  return size ? styles["".concat(SIZES_MAP[size], "-size")] || '' : '';
};

exports.getSizeClassName = getSizeClassName;